import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'

import DataTable from 'Shared/Components/DataTable'
import Player from 'Pages/Portal/Surveillance/Live/components/Player'

const CameraMonitor = ({ data }) => {
  const { t } = useTranslation()

  const [liveUrl, setLiveUrl] = useState()

  const [isVisible, setIsVisible] = useState(document.visibilityState === 'visible');
  const [token, setToken] = useState(localStorage.getItem("access_token"))

  useEffect(() => {
    const handleStorageChange1 = (e) => {
      setToken(localStorage.getItem("access_token"))
    };
  
    const handleStorageChange2 = (e) => {
        if (e.key === "access_token") {
        setToken(localStorage.getItem("access_token"))
      }
    };

    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener("access_token_change", handleStorageChange1);
    window.addEventListener("storage", handleStorageChange2);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);

      window.removeEventListener("access_token_change", handleStorageChange1);
      window.removeEventListener("storage", handleStorageChange2);
    };
  }, []);

  const openLive = (row) => {
    if (liveUrl != null) {
      if (row["camera_id"] === liveUrl["camera_id"]) {
        return
      }
    }

    setLiveUrl(row)
  }

  return (<>
    <div style={{ width: "100%", height: "100%", backgroundColor: "#FFFFFF", borderRadius: "10px", display: "flex", flexDirection: "column", overflow: "auto", padding: "10px" }}>
      <div><b>{t("module_live")}</b></div>

      <div style={{ display: "flex", flexDirection: "row", width: "100%", height: "100%", overflow: "auto" }}>
        {data.length > 0 ? (<>
          <div style={{ width: "50%", height: "100%" }}>
            <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
              <DataTable
                onRowClick={(_, row) => openLive(row)}
                data={data}
                columns={{
                  "online": { "label": "", "sorting": false, "nowrap": true },
                  "name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                }}
              />
            </Paper>
          </div>
        
          <div style={{ width: "50%", height: "100%", paddingLeft: "10px", paddingRight: "10px", overflow: "hidden" }}>
            {liveUrl ? (
              <Player clearStream={() => setLiveUrl()} item={[`live/${liveUrl["camera_id"]}`, liveUrl["name"]]} isVisible={isVisible} token={token}/>
            ) : (
              <div></div>
            )}
          </div>
        </>) : (
          <div style={{ width: "100%", flexGrow: 1, display: "flex", flexDirection: "column", overflow: "auto", alignItems: "center", justifyContent: "center" }}>
          <div><b>{t("general_noInfo")}</b></div>
          </div>
        )}
      </div>
    </div>
  </>)
}

export default CameraMonitor
